import BannerManager from "./BannerManager";
import { BANNER_TYPES } from "../Utils/constant";

function SecondaryBanners() {
  return (
    <BannerManager
      bannerType={BANNER_TYPES.SECONDARY}
      title="Secondary Banner"
      description="Manage wide secondary banners shown in the shop app. Inactive banners are hidden from customers."
    />
  );
}

export default SecondaryBanners;
